import React from 'react';

import Header from '../../layout/Header.jsx';
import ListAnnouncements from '../../lists/ListAnnouncements.jsx';

const PageAnnouncements = () => (
  <div>
    <Header>Announcements</Header>
    <ListAnnouncements />
  </div>
);

export default PageAnnouncements;
